import React, { useEffect, useRef, useState } from 'react';
import { Tooltip } from '@mui/material';

interface PartNumberCellProps {
  value: string | null;
}

const PartNumberCell: React.FC<PartNumberCellProps> = ({ value }) => {
  const textRef = useRef<HTMLParagraphElement>(null);
  const [showTooltip, setShowTooltip] = useState(false);
  const displayValue = value ?? '';

  useEffect(() => {
    if (textRef.current) {
      setShowTooltip(textRef.current.scrollWidth > textRef.current.clientWidth + 1);
    }
  }, [displayValue]); 

  return (
    <Tooltip title={displayValue} disableHoverListener={!showTooltip}>
      <p
        ref={textRef} 
        className="partNumberColluns"
        style={{
          cursor: "pointer",
          margin: 0,
          width: "100%", 
          overflow: "hidden", 
          textOverflow: "ellipsis",
          whiteSpace: "nowrap", 
          display: "block", 
        }}
      >
        {displayValue}
      </p>
    </Tooltip>
  );
};

export default PartNumberCell;